import Keycloak from 'keycloak-js';

// Keycloak configuration
const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_URL || 'https://your-keycloak-domain.com',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'glucoscout',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'glucoscout-frontend',
};

// Create Keycloak instance
const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
